module.exports = __webpack_public_path__ + "static/media/clothing.8934a3a9.svg";